import React, { Component } from 'react';
import { translate } from 'react-i18next';

import SecurityBoxLogo from '../SecurityBoxLogo';

class InvalidLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderText: 'Invalid link text'
    };
  }

  render() {
    const { t } = this.props;
    const { loaderText } = this.state;

    return (
      <div>
        <SecurityBoxLogo />
        <p style={{ textAlign: 'center', marginTop: 55 }}>
          <h4 style={{ fontSize: 18, color: '#252b49', fontWeight: 'normal' }}>{t(loaderText)}</h4>
        </p>
      </div>
    );
  }
}

export default translate(['ui'])(InvalidLink);



// WEBPACK FOOTER //
// ./components/info/InvalidLink.jsx